import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getQaOssPolicy = () =>
  httpClient.get(apis.QA_QUESTION_OSS_POLICY, { ignore: true, ignoreLoading: true });
export const getNoteOssPolicy = () =>
  httpClient.get(apis.NOTE_OSS_POLICY, { ignore: true, ignoreLoading: true });
export const uploadQaImg = (url, payload) =>
  httpClient.post(url, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    withCredentials: false,
    //timeout: 180000,
  });
